// Styles start
// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.

import { blueGrey, lightBlue } from "../../../../themes/palette"
import { makeStyles } from "tss-react/mui"

// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
export const styles = makeStyles()(({ zIndex, spacing }) => ({
  // "@global": {
  // " ": { opacity: 1 }
  // },
  root: {
    backgroundColor: "transparent",
    marginLeft: -15,
    position: "relative",
    maxWidth: "calc(20% + 15px)",
    zIndex: 2,
    "&.active": {
      marginRight: 4,
      "&:not(:last-child)": {
        maxWidth: "20%"
      },
      "& > :first-of-type": {
        width: "100%",
        "& > .filterBtnContent": {
          width: "100%"
        }
      },
      "&:not(:first-of-type)": {
        marginLeft: -20
      }
    },
    "&.active + :not(.active) ": {
      marginLeft: -19
    },

    "&:first-of-type": {
      marginLeft: 0,
      "& .filterBtnContent": {
        paddingLeft: 12,
        borderLeft: `1px solid ${lightBlue[300]}`,
        borderRadius: 3
      }
    },
    "&:nth-of-type(2)": {
      "& .filterBtn": {
        "&::after": {
          right: 6
        }
      }
    },
    "&:nth-of-type(3)": {
      "& .filterBtn": {
        "&::after": {
          right: 6
        }
      }
    },
    "&:nth-of-type(4)": {
      "& .filterBtn": {
        "&::after": {
          right: 6
        }
      }
    },

    // last element clipping fix
    "&:nth-last-of-type(2):not(.active)": {
      "& ~ *.active": {
        "& .filterBtnContent": {
          clipPath:
            "polygon(4px 0%, 100% 0%, 100% 100%, 4px 100%, 20px 15px, 20px 16px)"
        }
      }
    },
    "&:last-child": {
      zIndex: 1,
      "& > :first-of-type::after": {
        content: "none"
      },
      "& > :first-of-type": {
        paddingRight: 0
      },
      "& .filterBtnContent": {
        paddingRight: spacing(2),
        borderRight: `1px solid ${lightBlue[300]}`,
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3
      }
    }
  },
  disabled: {
    pointerEvents: "none",
    color: blueGrey[500],
    "& > :first-of-type::after": {
      borderTop: `1px solid ${blueGrey[100]}`, //"2px solid #fff",
      borderRight: `1px solid ${blueGrey[100]}`, // "2px solid #fff",
      backgroundColor: "rgb(236, 239, 241)"
    },
    // & > filterBtn .filterBtnContent
    "& > :first-of-type .filterBtnContent": {
      borderTop: `1px solid ${blueGrey[100]}`,
      borderBottom: `1px solid ${blueGrey[100]}`
    },
    "&:last-child": {
      "& .filterBtnContent": {
        borderRight: `1px solid ${blueGrey[100]}`
      }
    }
  },

  filterButton: {
    display: "flex",
    overflow: "hidden",
    cursor: "pointer",
    // border: "1px solid black",
    height: 30,
    position: "relative",
    paddingRight: 15,
    backgroundColor: "inherit",
    "&  .filterTypeIcon": {
      marginRight: spacing(2),
      fontSize: "1rem"
    },
    "&:hover .filterBtnContent": {
      backgroundColor: lightBlue[50],
      zIndex: 11
    },
    "&:hover::after": {
      backgroundColor: lightBlue[50],
      zIndex: 10
    },
    // filterButton > .filterContent
    "& > :first-of-type": {
      paddingLeft: 24,
      display: "flex",
      height: "100%",
      alignItems: "center",
      borderTop: `1px solid ${lightBlue[300]}`,
      borderBottom: `1px solid ${lightBlue[300]}`
    },
    "&::after": {
      content: "''",
      // backgroundColor: "inherit",
      height: 30, // 24,
      width: 30, // 24 ,
      // zIndex: 1,
      zIndex: -1,
      boxSizing: "border-box",
      position: "absolute",
      right: 7, // 6 or 4?
      top: "50%",
      borderTop: `1px solid ${lightBlue[300]}`, //"2px solid #fff",
      borderRight: `1px solid ${lightBlue[300]}`, // "2px solid #fff",
      backgroundColor: "rgb(236, 239, 241)",

      borderTopRightRadius: 3,
      transform: " translateY(-50%) rotate(45deg)"
    }
  },
  adminColors: {
    border: "none",
    color: "#fff",

    "&:not(:last-of-type)": {
      "& > :first-of-type::after": {
        borderColor: "#fff",
        borderWidth: 2
      }
    },
    "& > :first-of-type > .filterBtnContent": {
      border: "none"
    },

    " &:nth-last-of-type(5)": {
      "& > :first-of-type > .filterBtnContent": {
        backgroundColor: "#0A526C"
      },
      "& > :first-of-type::after": {
        backgroundColor: "#0A526C",
        right: 5
      },
      "&.active": {
        zIndex: 15,
        "&:hover": {
          "& .filterBtnContent": {
            borderRadius: "0 5px 5px 0"
          }
        }
      }
    },
    " &:nth-last-of-type(4)": {
      "& > :first-of-type > .filterBtnContent": {
        backgroundColor: "#0B5C7A",
        borderRadius: "0px 5px 5px 0px"
      },
      "& > :first-of-type::after": {
        backgroundColor: "#0B5C7A",
        right: 5
      },
      "&.active": {
        zIndex: 14,
        "&:hover": {
          "& .filterBtnContent": {
            borderRadius: "0 5px 5px 0"
          }
        }
      }
    },
    " &:nth-last-of-type(3)": {
      "& > :first-of-type > .filterBtnContent": {
        backgroundColor: "#0C6788",
        borderRadius: "0px 5px 5px 0px"
      },
      "& > :first-of-type::after": {
        backgroundColor: "#0C6788",
        right: 5
      },
      "&.active": {
        zIndex: 13,
        "&:hover": {
          "& .filterBtnContent": {
            borderRadius: "0 5px 5px 0"
          }
        }
      }
    },
    " &:nth-last-of-type(2)": {
      "& > :first-of-type > .filterBtnContent": {
        backgroundColor: "#0E7296",
        borderRadius: "0px 5px 5px 0px"
      },
      "& > :first-of-type::after": {
        backgroundColor: "#0E7296",
        right: 5
      },
      "&.active": {
        zIndex: 12,
        "&:hover": {
          "& .filterBtnContent": {
            borderRadius: "0 5px 5px 0"
          }
        }
      }
    },
    " &:nth-last-of-type(1)": {
      "& > :first-of-type > .filterBtnContent": {
        backgroundColor: lightBlue[600]
      },
      "& > :first-of-type::after": {
        backgroundColor: lightBlue[600]
      },
      "&.active": {
        zIndex: 11
      }
    }
  },
  filterBtnLabel: {
    lineHeight: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.75rem"
  },

  selected: {
    backgroundColor: "#E0F7FA"
  },

  popper: {
    zIndex: zIndex.modal,
    minWidth: 165,
    width: "100%",
    maxHeight: 200
  },
  dropdownRoot: {
    padding: spacing(2, 1)
  },

  // Search textfield styles start
  searchFieldRoot: {
    marginBottom: spacing(2),
    width: `100%`,
    paddingLeft: spacing(1),
    paddingRight: spacing(2),
    border: `1px solid ${blueGrey[200]}`,

    "&:focus-within": {
      borderColor: lightBlue[300],
      outline: `3px solid rgba(126,207,232,0.2)`
    },
    "& fieldset": {
      borderColor: "transparent !important"
    },
    "&:hover fieldset": {
      borderColor: "transparent !important"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent !important"
    },

    "& > .MuiInputAdornment-positionStart": {
      marginRight: spacing(1)
    },

    "& > .MuiOutlinedInput-input": {
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
      color: blueGrey[800]
    }
  },
  // Search textfield styles end

  // listitem styles
  listItem: {
    overflow: "hidden",
    width: "100%",
    padding: spacing(2, 3)
  },
  listText: {
    "& span": {
      fontSize: 14,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: blueGrey[800]
    }
  },
  // listitem styles

  noFoundAlert: {
    width: "100%",
    padding: spacing(2),
    backgroundColor: lightBlue[100],
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderRadius: "3px"
  },
  noFoundAlertIcon: {
    width: 15,
    height: 15,
    border: `2px dashed ${lightBlue[600]}`,
    borderRadius: "50%"
  },
  noFoundAlertText: {
    color: lightBlue[800],
    marginLeft: spacing(2),
    fontWeight: 400
  },
  emptyFilterText: {
    color: lightBlue[800],
    lineHeight: "1rem",
    marginLeft: spacing(2)
  },

  // loader start
  loader: {
    display: "flex",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center"
  }
  // loader end
}))
// Styles end
